import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import type { PublicConfig } from '@ousse/shared'
import { api } from '../lib/api'

/**
 * Page de confidentialité (brief, données personnelles) : décrit ce que fait vraiment le logiciel ; les
 * informations sur la personne qui héberge l'instance viennent de la configuration (`LEGAL_*`).
 */
export function PrivacyPage() {
  const { t } = useTranslation()
  const config = useQuery({ queryKey: ['config'], queryFn: () => api.get<PublicConfig>('/config') })
  const legal = config.data?.legal
  const list = (key: string) => t(key, { returnObjects: true }) as string[]

  return (
    <article className="stack">
      <h1>{t('privacy.title')}</h1>
      <p>{t('privacy.intro')}</p>

      <h2>{t('privacy.whoTitle')}</h2>
      <dl className="stack">
        <div>
          <dt>{t('privacy.publisher')}</dt>
          <dd>{legal?.publisher ?? <em>{t('privacy.notSet')}</em>}</dd>
        </div>
        <div>
          <dt>{t('privacy.contact')}</dt>
          <dd>{legal?.contactEmail ? <a href={`mailto:${legal.contactEmail}`}>{legal.contactEmail}</a> : <em>{t('privacy.notSet')}</em>}</dd>
        </div>
        <div>
          <dt>{t('privacy.host')}</dt>
          <dd>{legal?.host ?? <em>{t('privacy.notSet')}</em>}</dd>
        </div>
      </dl>

      {(['collected', 'notCollected', 'sharing'] as const).map((section) => (
        <section key={section}>
          <h2>{t(`privacy.${section}Title`)}</h2>
          <ul>
            {list(`privacy.${section}`).map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        </section>
      ))}

      <h2>{t('privacy.retentionTitle')}</h2>
      <p>{t('privacy.retention', { days: config.data?.trashRetentionDays ?? 30 })}</p>

      <h2>{t('privacy.rightsTitle')}</h2>
      <p>{t('privacy.rights')}</p>
    </article>
  )
}
